import * as angular from 'angular';

import { tokenFromVizID } from '@mode/charts/domain';
import { RowHeights } from '@mode/reports/sandbox/contract';
import QuillEditorModule from './quill-editor-module';
import TextBlockController from './text-block-controller';

interface ITextBlockScope extends angular.IScope {
  view: any;
}

interface ITextBlockAttrs extends angular.IAttributes {
  canEdit: any;
  id: string;
}

const TOOLBAR_ADDONS_TEMPLATE = `
  <div class="text-toolbar-addons">
    <span class="ql-formats">
      <button type="button" ng-class="{'ql-active': ctrl.hasMargins(), 'disabled': ctrl.getRowHeight() !== 'full'}" class="ql-margins" ng-click="ctrl.toggleMargins()"></button>
      <button type="button" class="ql-set-height" ng-click="ctrl.toggleSizePicker()">
        <i class="icon-toolbar-caret"></i>
        <div class="text-block-size-dropdown">
          <div class="header">HEIGHT</div>
          <div class="toggle-btn-group">
            <a ng-click="ctrl.setRowHeight('${RowHeights.Small}')" ng-class="{active: ctrl.getRowHeight() === '${RowHeights.Small}'}">S</a>
            <a ng-click="ctrl.setRowHeight('${RowHeights.Medium}')" ng-class="{active: ctrl.getRowHeight() === '${RowHeights.Medium}'}">M</a>
            <a ng-click="ctrl.setRowHeight('${RowHeights.Large}')" ng-class="{active: ctrl.getRowHeight() === '${RowHeights.Large}'}">L</a>
            <a ng-class="{active: ctrl.getRowHeight() === '${RowHeights.Full}'}"
                ng-click="ctrl.setRowHeight('${RowHeights.Full}')">Full</a>
          </div>
        </div>
      </button>
      <button type="button" class="ql-remove" ng-click="ctrl.removeTextBlock()"></button>
    </span>
  </div>
`;

export const TextBlockDirective: angular.IDirectiveFactory = ($compile: angular.ICompileService) => ({
  scope: {
    textContent: '<',
    textChanged: '&',
    onRemove: '&',
    onToggleMargins: '&?',
    onSetRowHeight: '&?',
    view: '<?setView',
  },
  bindToController: true,
  restrict: 'E',
  controller: TextBlockController,
  controllerAs: 'ctrl',
  template: `
        <div class="editor-module editor-chart editor-multi mode-object text-block-container">
          <div class="chart-content text-block-content"></div>
        </div>
    `,
  link: (scope: ITextBlockScope, elem, attrs: ITextBlockAttrs, ctrl: TextBlockController) => {
    ctrl.editor = new QuillEditorModule({
      textContents: ctrl.textContent != null ? ctrl.textContent : ctrl.view && ctrl.view.textContents,
      isEditing: attrs.canEdit === 'true',
      onClickRemove: ctrl.removeTextBlock,
      onTextChange: ctrl.onTextChange,
    });

    ctrl.token = tokenFromVizID(attrs.id);
    scope.editMode = attrs.canEdit === 'true';

    const toolbarAddons = $compile(TOOLBAR_ADDONS_TEMPLATE)(scope);
    ctrl.editor.$toolbar.append(toolbarAddons);

    elem.find('.text-block-content').append(ctrl.editor.$el);
    ctrl.editor.$toolbar.insertBefore(elem);

    ctrl.editor.postInit();

    if (attrs.canEdit === 'false') {
      elem.find('.text-block-container').addClass('report-view');
    }
  },
});

TextBlockDirective.$inject = ['$compile'];
